import { useQuery } from "@tanstack/react-query";
import { fetchOrganizationRoles } from "../../../services/b2b-users-apiService";
import { useLoginContext } from "../../../App";
import { useState } from "react";
import { useContentContext } from "../../layout/Layout";
import { showNotification } from "../../b2b-common/Notification";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useGetOrganizationRoles = () => {
    const { t } = useB2BTranslation('b2b-users');
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const [isLoading, setIsLoading] = useState(false);

    const getOrganizationRoles = async () => {
        try {
            const organizationUUID = loginData.loggedOrganizationUuid;
            setIsLoading(true);
            const roles = await fetchOrganizationRoles(organizationUUID, loginData.accessToken);
            return roles;
        } catch (error) {
            console.error('Error fetching organization roles:', error);
            showNotification(setNotification, t('Error fetching organization roles'), 'error', 5000);
        } finally {
            setIsLoading(false);
        }
    }

    const { data: organizationRoles } = useQuery({
        queryKey: ['organizationRoles', loginData.loggedOrganizationUuid],
        queryFn: getOrganizationRoles,
        enabled: !!loginData?.loggedOrganizationUuid,
        staleTime: 30 * 60 * 1000, // 30 minutes
    });

    return { organizationRoles, isLoading };

}

export default useGetOrganizationRoles;